import React, { FC } from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { Button, Col, Drawer, Row, Typography } from 'components';
import { ADMIN_ROUTES } from 'constants/routes';
import { Link } from 'react-router-dom';

const { Text } = Typography;

interface IRolesDrawer {
  onExpand: () => void;
  drawerState: boolean;
  data?: Record<string, any>[];
}

export const SuppliersDrawer: FC<IRolesDrawer> = React.memo((props) => {
  const { onExpand, drawerState, data } = props;
  return (
    <Drawer
      closeIcon={null}
      placement="left"
      width={471}
      open={drawerState}
      onClose={() => onExpand()}
      styles={{
        header: {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        },
      }}
      title={'Suppliers'}
    >
      <div style={{ position: 'absolute', right: 16, top: 16 }}>
        <Button icon={<CloseOutlined />} onClick={() => onExpand()} type="text" />
      </div>
      <Row>
        {data?.map((supplier) => (
          <Col key={supplier.id} span={24} className={'padding-8'}>
            <Link to={`${ADMIN_ROUTES.suppliers.view}/${supplier.id}/general`} target={'_blank'}>
              <Text type={'secondary'} underline>
                {supplier.name}
              </Text>
            </Link>
          </Col>
        ))}
      </Row>
    </Drawer>
  );
});
